import { useEffect, useRef, useState } from "react";
import { getCustomisationValue, getGroupData } from "../../../EditablePreview";
import InlineProgressBar, { convertCustomisationDataToBarSettings } from "../../progress-bar/inline-progress-bar";
import VisualisedNode, { IMAGE_MODES } from "../../VisualisedNode";
import './WaveHands.scss';

const MAX_HANDS = 70;
const HANDS_APPEAR_DELAY = 300; // milliseconds
const HANDS_RESET_DELAY = 3000; // milliseconds

const WaveHands = (props) => {
    // console.log("WaveHands props:", props);
    const node = props.node;

    const handsGroupData = getGroupData(props.node.customisationVars, 'hands.objects.handObject', -1);
    // console.log("Hands group data:", handsGroupData);

    const [randomHands, setRandomHands] = useState([]);
    const randomHands_ref = useRef(randomHands);
    const [handsInterval, setHandsInterval] = useState(null);
    const handsInterval_ref = useRef(handsInterval);
    const [handsResetTimeout, setHandsResetTimeout] = useState(null);
    const handsResetTimeout_ref = useRef(handsResetTimeout);
    useEffect(() => {
        randomHands_ref.current = randomHands;
        handsInterval_ref.current = handsInterval;
        handsResetTimeout_ref.current = handsResetTimeout;
    }, [randomHands, handsInterval, handsResetTimeout]);
    const clearAllHands = () => {
        //if (props.timelinePlayheadStep === 0) {
            setRandomHands([]);
            setHandsInterval(setInterval(addRandomHand, HANDS_APPEAR_DELAY));
        /*}  else {
            setHandsResetTimeout(setTimeout(() => {
                clearAllHands();
            }, HANDS_RESET_DELAY));
        } */
    }
    const addRandomHand = () => {
        /* if (props.timelinePlayheadStep > 0 && randomHands_ref.current.length < MAX_HANDS) {
            while (randomHands_ref.current.length < MAX_HANDS) {
                setRandomHands(prev => [...prev, {
                    index: Math.floor(Math.random() * handsGroupData.length),
                    x: (Math.random() * 100) + '%',
                    y: (Math.random() * 40) + 60 + '%',
                }]);
            }
        } else */
        if (randomHands_ref.current.length < MAX_HANDS) {

            const handsFrequency = [];
            for (let i = 0; i < handsGroupData.length; i++) {
                for (let j = 0; j < (handsGroupData[i].appearFrequency || 1); j++) {
                    handsFrequency.push(i);
                }
            }

            setRandomHands(prev => [...prev, {
                index: handsFrequency[Math.floor(Math.random() * handsFrequency.length)],
                x: (Math.random() * 100) + '%',
                y: (Math.random() * 40) + 60 + '%',
            }]);
        } else {
            clearInterval(handsInterval_ref.current);
            setHandsInterval(null);
            if (handsResetTimeout_ref.current) {
                clearTimeout(handsResetTimeout_ref.current);
            }
            setHandsResetTimeout(setTimeout(() => {
                clearAllHands();
            }, HANDS_RESET_DELAY));
        }
    }
    useEffect(() => {
        console.log("WaveHands useEffect - timelinePlayheadStep:", props.timelinePlayheadStep, props);
        if (props.timelinePlayheadStep === 0) {
            clearInterval(handsInterval_ref.current);
            if (handsResetTimeout_ref.current) {
                clearTimeout(handsResetTimeout_ref.current);
            }
            clearAllHands();
        } else {
            clearInterval(handsInterval_ref.current);
            setHandsInterval(null);
            if (handsResetTimeout_ref.current) {
                clearTimeout(handsResetTimeout_ref.current);
            }
            const handsArray = randomHands;
            while (handsArray.length < MAX_HANDS) {
                handsArray.push({
                    index: Math.floor(Math.random() * handsGroupData.length),
                    x: (Math.random() * 100) + '%',
                    y: (Math.random() * 40) + 60 + '%',
                });
            }
        }
        return () => {
            clearInterval(handsInterval);
            clearTimeout(handsResetTimeout);
        };
    }, [props.timelinePlayheadStep, handsGroupData.length]);

    return (
        <>
            {
                randomHands.map((hand, index) => {
                    return (
                        <img 
                            key={index}
                            src={handsGroupData?.[hand.index]?.filename?.srcUrl ?? ''}
                            alt={`Hand ${index}`}
                            className="wave-hand"
                            style={{
                                position: 'absolute',
                                left: hand.x,
                                top: hand.y,
                                transform: `translate(-50%, -50%) scale(${props.previewScale}) scale(${handsGroupData?.[hand.index].imageScale ?? 100}%)`,
                                opacity: (props.node === props.visualisedNode && props.activeNode !== props.node && props.activeNode.dataIndex !== hand.index) ? 0.25 : 1,
                            }}
                        />
                    );
                })
            }
            {/*node === props.visualisedNode &&
                <div className="wave-hands-list-holder">
                    {handsGroupData && handsGroupData.map((hand, index) => {
                        return <VisualisedNode key={index} {...props} node={node} imageMode={IMAGE_MODES.naturalSize} index={index} contentNode={true} />
                    })}
                </div>
            */}
        </>
    )
}

export default WaveHands;
